import React from 'react';
import { TableRow } from '@material-ui/core';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import { etiquetaDeTipo } from './inventarioMovimientosTipos.js';

/**
 * VEC-3315 Scenarios 01 y 02 — una fila del historial global de movimientos.
 *
 * EL GRANO ES LA LÍNEA, NO LA CABECERA. Un movimiento con líneas de tres ítems son tres filas, cada
 * una con su ítem, su cantidad y su costo. La cabecera se ve entera en el detalle (Scenario 04), que
 * es la única vista donde se aprecia que un movimiento puede involucrar varios ítems.
 *
 * NUNCA SE MUESTRA EL SIGNO. La dirección se lee de Tipo más Origen → Destino, y por eso hay DOS
 * columnas de ubicación y no una sola "Depósito": una transferencia entre dos depósitos es egreso de
 * uno e ingreso del otro, así que con más de un depósito filtrado no hay un signo correcto —el
 * backend manda `esIngreso` en null a propósito en ese caso—. Pintar un signo obligaría a elegir un
 * punto de vista que la pantalla no tiene.
 */
const InventarioMovimientosGridRow = (props) => {
  const intl = props.intl;
  const row = props.row;

  /** Las cantidades son ENVASES: enteros. El decimal vive en el factor de la unidad de medida. */
  const formatEntero = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return LocaleFormat.formatNumber(Number(value), 0);
  };

  /**
   * Sin símbolo de moneda: los valores monetarios del módulo están fuera de alcance hasta VEC-3325
   * (multimoneda). El número se muestra igual —el permiso de esta pantalla existe justamente porque
   * expone costos y responsables— pero sin comprometerse con una moneda que el modelo no tiene.
   *
   * `null` es "ingreso sin precio", que es un caso legítimo y distinto de un costo en 0 (donación,
   * garantía). Por eso el vacío se muestra como guion y no como "0".
   */
  const formatCosto = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return LocaleFormat.formatNumber(Number(value), 2);
  };

  const nombreUbicacion = (u) => (u && u.nombre ? u.nombre : '-');

  const item = row.item || {};

  return (
    <TableRow>
      <StyledTableCell align="left">{row.fecha ? LocaleFormat.formatDate(row.fecha) : '-'}</StyledTableCell>
      <StyledTableCell align="left">{etiquetaDeTipo(intl, row.tipo)}</StyledTableCell>
      <StyledTableCell align="left">{item.numeroDeParte || '-'}</StyledTableCell>
      <StyledTableCell align="left">{item.descripcion || '-'}</StyledTableCell>
      {/* Origen vacío no es un dato faltante: un ingreso puro no tiene origen, entra desde afuera
          del sistema. Se muestra como guion, igual que el destino de un egreso. */}
      <StyledTableCell align="left">{nombreUbicacion(row.ubicacionOrigen)}</StyledTableCell>
      <StyledTableCell align="left">{nombreUbicacion(row.ubicacionDestino)}</StyledTableCell>
      <StyledTableCell align="right">{formatEntero(row.cantidad)}</StyledTableCell>
      <StyledTableCell align="right">{formatCosto(row.costo)}</StyledTableCell>
      <StyledTableCell align="left">{row.usuario || '-'}</StyledTableCell>
      <StyledTableCell align="center">
        <div className="d-inline-flex">
          {/* Scenario 04: el detalle es de la CABECERA, así que se pide por `movimientoId` y no por
              el id de esta fila, que es el de la línea. */}
          <StyledTooltip
            title={intl.formatMessage({
              id: 'inventarioMovimientos.grid.ver_detalle',
              defaultMessage: 'Ver detalle del movimiento',
            })}
            arrow
            placement="top"
          >
            <button
              className="action view btn btn-sm btn-icon btn-dt-grid text-success"
              onClick={() => props.onVerDetalle(row.movimientoId)}
            >
              <i className="fa fa-search fa-xs" />
            </button>
          </StyledTooltip>
        </div>
      </StyledTableCell>
    </TableRow>
  );
};

export default InventarioMovimientosGridRow;
